/* eslint-disable no-console */
/**
 * Quyền ở mức HÀNH ĐỘNG (không phải mức màn hình).
 *
 * Nguồn sự thật là per_menu.code — cùng danh sách mà backend dùng để sinh authority
 * ROLE_<code> (AuthenFillter). Sidebar chỉ chứa node điều hướng (type = 0) nên không đủ
 * để biết user có quyền chức năng nào; vì vậy phải lấy riêng qua GET /menu/staff/codes.
 *
 * Cache trong localStorage để render đồng bộ (columns của element-react Table dựng trong
 * constructor, không chờ được promise). Đây CHỈ là lớp ẩn/hiện UI — chốt chặn thật nằm ở
 * WebSecurityConfig phía backend.
 */
import { axiosInstance } from '../axios-config';
import * as systemConstants from '../constants/systemConstants';

const STORAGE_KEY = 'permissionCodes';

// hasPermission được gọi trong render của từng dòng bảng, nên giữ bản đã parse trong bộ nhớ
// thay vì JSON.parse localStorage mỗi lần.
let cachedCodes = null;

/**
 * Nạp permission code của user hiện tại và cache lại.
 * Gọi ở 2 nơi: ngay sau khi login (để màn hình đầu tiên đã có quyền) và khi Navigation
 * mount (để mỗi lần F5 quyền được làm mới sau khi admin thay đổi vai trò).
 *
 * @returns {Promise<Array<string>>} danh sách permission code
 */
export async function loadPermissions() {
  try {
    const fullUrl = systemConstants.API_URL + 'menu/staff/codes';
    const response = await axiosInstance.get(fullUrl, systemConstants.HEADERS());
    const codes = (response && response.data && response.data.data) || [];
    cachedCodes = codes;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(codes));
    return codes;
  }
  catch (error) {
    // Giữ nguyên cache cũ thay vì xoá trắng: mất mạng tạm thời không nên làm biến mất
    // hết nút bấm của user.
    console.error(systemConstants.MESSAGES.ERROR_COLLECTING_DATA, error);
    return getPermissions();
  }
}

/**
 * @returns {Array<string>} permission code đang cache
 */
export function getPermissions() {
  if (cachedCodes) {
    return cachedCodes;
  }
  try {
    cachedCodes = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  }
  catch (error) {
    cachedCodes = [];
  }
  return cachedCodes;
}

/**
 * @param {string} code permission code, ví dụ 'staff_role'
 * @returns {boolean} user hiện tại có quyền này không
 */
export function hasPermission(code) {
  return getPermissions().indexOf(code) !== -1;
}

/**
 * @param {Array<string>} codes danh sách permission code
 * @returns {boolean} user có ÍT NHẤT MỘT trong các quyền trên không
 */
export function hasAnyPermission(codes = []) {
  const granted = getPermissions();
  return codes.some((code) => granted.indexOf(code) !== -1);
}

export function clearPermissions() {
  cachedCodes = null;
  localStorage.removeItem(STORAGE_KEY);
}
